<template>
	<div class="pager">
		<div class="page-line">
			<div class="page-total">
				共{{total}}页 {{msgNum}}条信息
			</div>
			<div class="first" @click="setCurrent(1)">
				第一页
			</div>
			<div class="prev" @click="setCurrent(current-1)">
				上一页
			</div>
			<div class="page-list">
				<div class="page-item" v-for="(item,index) in list" :key="index" :id="item==current?'select':''" @click="setCurrent(item)">
					{{item}}
				</div>
			</div>
			<div class="next" @click="setCurrent(current+1)">
				下一页
			</div>
			<div class="last" @click="setCurrent(total)">
				最后一页
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'pager',
		props:['total','msgNum'],
		data() {
			return {
				list:[],
				current:1
			};
		},
		computed:{
			getTotal(){
				return this.$props.total
			}
		},
		watch: {
			getTotal(total){
				this.initPage()
			}
		},
		methods:{
			initPage(){
				this.list = []
				let end,start
				if(this.$props.total>9){
					if(this.current<6){
						end = 9
						start = 0
					}else if(this.current>this.$props.total-5){
						end = this.$props.total
						start = this.$props.total-9
					}else{
						end = this.current+4
						start = this.current-5
					}
				}else{
					start = 0
					end = this.$props.total
				}
				for (let i = start; i < end; i++) {
					this.list.push(i+1)
				}
			},
			setCurrent(num){
				this.current = num
				this.$emit('getPage',num)
				this.list = []
				this.initPage()
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.initPage()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style lang="less" scoped="scoped">
	.pager{
		width: 100%;
		height: 100px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		.page-line{
			width: 100%;
			height: 40px;
			display: flex;
			justify-content: flex-end;
			.page-total,.first,.prev,.page-list,.next,.last{
				padding: 0px 10px;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 14px;
			}
			.first:hover,.prev:hover,.next:hover,.last:hover{
				cursor: pointer;
				color: #FFFFFF;
				background: #23b8ff;
				border-radius: @vue-border-radius-base;
			}
			.page-list{
				justify-content: space-between;
				.page-item{
					width: 40px;
					height: 100%;
					border: 1px solid #D3D3D3;
					box-sizing: border-box;
					border-radius:  @vue-border-radius-base;
					display: flex;
					justify-content: center;
					align-items: center;
					margin-right: 8px;
					cursor: pointer;
				}
				.page-item:last-child{
					margin-right: 0px;
				}
				#select{
					color: #FFFFFF;
					background: #23b8ff;
				}
				.page-item:hover{
					color: #FFFFFF;
					background: #23b8ff;
				}
			}
		}
	}
</style>
